import React, { Fragment } from "react";

export const ActivitiesPage: React.FC = () => {
  return (
    <Fragment>
      <div>Activities</div>
    </Fragment>
  );
};
